import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

export const LoginInputNumber = styled.input`
  width: 48px !important;
  height: 56px;
  font-size: 24px;
  border-radius: 8px;
  text-align: center;
  margin-right: 10px;
  border: 0;

  &:last-child {
    margin-right: 0;
  }

  &:focus {
    border: 1px solid ${color.primary};
  }
`;

export const InputPINWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 300px;
  height: 48px;

  #pin-mask {
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 300px;
    height: 48px;
    gap: 4px;
  }
`;

export const InputPINNumber = styled.input.attrs({
  type: 'text',
})`
  z-index: 9999;
  background: transparent;
  width: 300px;
  text-align: center;
  font-size: 20px;
  border: none;
  outline: none;
  color: transparent;
  letter-spacing: 12px;
  caret-color: #00AB6B;
  font-weight: bold;

  ::selection {
    color: transparent;
  }
`;

export const ErrorMessageWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  gap: 6px;
  align-items: center;
  justify-content: center;
`;
